import classNames from 'classnames';
import React, { FC } from 'react';
import { EmptyState as EmptyStateWSR } from '../wixCommon';
import styles from './EmptyStateGeneric.scss';
import { IOuter } from './EmptyStateGeneric.types';

export const EmptyStateGeneric: FC<IOuter> = ({
  title,
  subtitle,
  image,
  children,
  className,
  dataHook = 'empty-state-generic',
}) => (
  <div className={classNames(styles.emptyStateHolder, className)}>
    <EmptyStateWSR
      image={image}
      title={title}
      subtitle={subtitle}
      dataHook={dataHook}
    >
      {children}
    </EmptyStateWSR>
  </div>
);
